import ErrorComponent from "./views/ErrorComponent.js";
import LoadingComponent from "./views/LoadingComponent.js";
import LogoComponent from "./views/LogoComponent.js";
import ForgotPasswordInstructionComponent from "./views/ForgotPasswordInstructionComponent.js";
import RequestLoginCodeInstructionComponent from "./views/RequestLoginCodeInstructionComponent.js";
import LoginByCodeInstructionComponent from "./views/LoginByCodeInstructionComponent.js";
import TwoFactorVerifyInstructionComponent from "./views/TwoFactorVerifyInstructionComponent.js";
import ExpiredActivationCodeInstructionComponent from "./views/ExpiredActivationCodeInstructionComponent.js";
import FieldErrorsComponent from "./views/FieldErrorsComponent.js";
import PasswordErrorsComponent from "./views/PasswordErrorsComponent.js";
import ResetPasswordInstructionComponent from "./views/ResetPasswordInstructionComponent.js";
const getShouldDisplayLogo = () => true;
export const ActivateAccountDefaultProps = {
  components: {
    ErrorComponent,
    LoadingComponent,
    LogoComponent,
    ExpiredActivationCodeInstructionComponent,
    FieldErrorsComponent,
    PasswordErrorsComponent
  },
  variants: {
    variant: 'loginPane',
    alreadyRegisteredVariant: 'tertiary',
    loginLogoVariant: 'loginLogo',
    passwordVariant: 'password|formInput'
  },
  options: {
    getShouldDisplayLogo,
    warningLocation: 'top'
  }
};
export const ResetPasswordDefaultProps = {
  components: {
    ErrorComponent,
    LoadingComponent,
    LogoComponent,
    FieldErrorsComponent,
    PasswordErrorsComponent,
    ResetPasswordInstructionComponent
  },
  variants: {
    variant: 'loginPane',
    loginLogoVariant: 'loginLogo',
    passwordVariant: 'password|formInput'
  },
  options: {
    getShouldDisplayLogo,
    warningLocation: 'top'
  }
};
export const LoginDefaultProps = {
  // Variants
  variants: {
    variant: 'loginPane',
    forgotVariant: 'forgotPasswordLink|link',
    labelVariant: 'loginHeader',
    identityProviderVariant: 'altLoginMethod',
    loginByCodeVariant: 'altLoginMethod',
    requestDeviceCodeVariant: 'altLoginMethod',
    loginLogoVariant: 'loginLogo',
    passwordVariant: 'password|formInput',
    usernameVariant: 'loginUser',
    warningVariant: 'loginWarning'
  },
  components: {
    ErrorComponent,
    LoadingComponent,
    LogoComponent
  },
  options: {
    getShouldDisplayLogo,
    loginByCodeEnabled: true,
    requestDeviceCodeEnabled: false,
    deviceCodeLoginIsDefault: false,
    warningLocation: 'top'
  },
  showIdentityProviders: true
};
export const ForgotPasswordDefaultProps = {
  variants: {
    variant: 'loginPane',
    backToLoginVariant: 'link',
    labelVariant: 'loginHeader',
    usernameVariant: 'loginUser',
    warningVariant: 'loginWarning',
    loginLogoVariant: 'loginLogo'
  },
  components: {
    ErrorComponent,
    ForgotPasswordInstructionComponent,
    LogoComponent,
    LoadingComponent
  },
  options: {
    getShouldDisplayLogo,
    warningLocation: 'top'
  }
};
export const LoginByCodeDefaultProps = {
  variants: {
    variant: 'loginPane',
    backToLoginVariant: 'link',
    loginLogoVariant: 'loginLogo',
    warningVariant: 'loginWarning'
  },
  components: {
    ErrorComponent,
    LoadingComponent,
    LogoComponent,
    LoginByCodeInstructionComponent
  },
  options: {
    getShouldDisplayLogo,
    warningLocation: 'top'
  }
};
export const RequestLoginCodeDefaultProps = {
  variants: {
    variant: 'loginPane',
    backToLoginVariant: 'link',
    warningVariant: 'loginWarning',
    loginLogoVariant: 'loginLogo'
  },
  components: {
    ErrorComponent,
    LoadingComponent,
    LogoComponent,
    RequestLoginCodeInstructionComponent
  },
  options: {
    getShouldDisplayLogo,
    warningLocation: 'top'
  }
};
export const RequestDeviceCodeDefaultProps = {
  variants: {
    variant: 'loginPane'
  }
};
export const TwoFactoryVerifyDefaultProps = {
  variants: {
    variant: 'loginPane',
    backToLoginVariant: 'link',
    backupCodeVariant: 'linkNeutralSmall',
    rememberMeVariant: 'small',
    resendCodeVariant: 'linkNoPad',
    twoFactorMethodRadioVariant: 'twoFactorMethodRadio',
    warningVariant: 'loginWarning'
  },
  components: {
    ErrorComponent,
    LoadingComponent,
    LogoComponent,
    TwoFactorVerifyInstructionComponent
  },
  options: {
    getShouldDisplayLogo,
    warningLocation: 'top'
  }
};
export const TwoFacterEnrollDefaultProps = {
  components: {
    ErrorComponent,
    LoadingComponent,
    LogoComponent
  },
  options: {
    getShouldDisplayLogo,
    warningLocation: 'top'
  },
  variants: {
    variant: 'loginPane',
    backToMethodSelectVariant: 'link'
  }
};
export const TWO_FACTOR_TYPES = {
  VERIFY: '2FAVerify',
  REQUIRE_ENROLL: '2FARequireEnroll',
  REMEMBER_ME: 'RememberMe'
};
export const TWO_FACTOR_ENROLL_STEPS = {
  OVERVIEW: 'OVERVIEW',
  SELECT_METHOD: 'SELECT_METHOD',
  PRE_ACTIVATE: 'PRE_ACTIVATE',
  CONFIRM: 'CONFIRM',
  ONE_TIME_CODES: 'ONE_TIME_CODES'
};
export const DEFAULT_ACTIVATE_ACCOUNT_OPTIONS = Object.freeze({
  path: '/activateAccount'
});
export const DEFAULT_LOGIN_OPTIONS = Object.freeze({
  path: '/login'
});
export const DEFAULT_DEVICE_LOGIN_OPTIONS = Object.freeze({
  path: '/login/device'
});
export const DEFAULT_FORGOT_PASSWORD_OPTIONS = Object.freeze({
  path: '/forgotPassword'
});
export const DEFAULT_REQUEST_LOGIN_CODE_OPTIONS = Object.freeze({
  path: '/requestLoginCode'
});
export const DEFAULT_REQUEST_DEVICE_CODE_OPTIONS = Object.freeze({
  path: '/requestDeviceCode'
});
export const DEFAULT_LOGIN_BY_CODE_OPTIONS = Object.freeze({
  path: '/loginByCode'
});
export const DEFAULT_TWO_FACTOR_VERIFY_OPTIONS = Object.freeze({
  path: '/twoFactorVerify'
});
export const DEFAULT_TWO_FACTOR_ENROLL_OPTIONS = Object.freeze({
  path: '/twoFactorEnroll'
});
export const DEFAULT_RESET_PASSWORD_OPTIONS = {
  path: '/resetPassword'
};
export const EMPTY_OBJ = Object.freeze({});
export const EMPTY_ARR = Object.freeze([]);